import { useAtomValue } from "jotai";
import { useEffect, useState } from "react";

import { paymentRequirementsAtom } from "checkout-experience/atoms/payment-atoms";
import { Modal3DS } from "checkout-experience/components/modal-3ds/modal-3ds";
import { ModalLpm } from "checkout-experience/components/modal-lpm/modal-lpm";
import { ModalPayByBankSDK } from "checkout-experience/components/modal-pay-by-bank/modal-pay-by-bank-sdk";
import { BrowserSettings } from "checkout-query-client/api/types";

const PaymentRequirements = () => {
  const [browserSettings, setBrowserSettings] = useState<BrowserSettings>({});
  const paymentRequirements = useAtomValue(paymentRequirementsAtom);
  const [requirement, setRequirement] = useState("");

  useEffect(() => {
    // if there are payment requirements and modal is not already open, pick one up
    if (
      paymentRequirements &&
      !!Object.keys(paymentRequirements).length &&
      !browserSettings?.isModalOpen
    ) {
      const requirementKey = Object.keys(paymentRequirements).find(
        (key: string) =>
          paymentRequirements[key as keyof typeof paymentRequirements] !==
          undefined
      );
      if (requirementKey) setRequirement(requirementKey);
    }
  }, [paymentRequirements, browserSettings]);

  // return a payment requirement component
  if (paymentRequirements && requirement) {
    switch (requirement) {
      case "threeDs":
        return (
          <Modal3DS
            src={paymentRequirements[requirement]}
            browserSettings={browserSettings}
            setBrowserSettings={setBrowserSettings}
          />
        );
      case "payByBankConsentUrl":
        return (
          <ModalPayByBankSDK
            browserSettings={browserSettings}
            setBrowserSettings={setBrowserSettings}
          />
        );
      case "lpm":
        return (
          <ModalLpm
            src={paymentRequirements[requirement]}
            browserSettings={browserSettings}
            setBrowserSettings={setBrowserSettings}
          />
        );
      default:
        return null;
    }
  }
  return null;
};

export default PaymentRequirements;
